export enum ACCESS_POLICY_MODULES {
  MY_SALES = 7,
  MY_CONTRACTS = 8,
  MY_PRODUCTS = 9,
  LINKS = 10,
  FINANCIAL = 11,
  DASHBOARD = 12,
  CENTRAL_TAX_DOCUMENTS = 13,
  MY_DELIVERIES = 15,
  HELP = 16,
  MY_LEADS = 17,
  CONNECT = 26,
  CHARGEBACK = 27,
  NUTROR = 28,
  WHITELIST = 44,
  PENDING_ACTIONS = 90,
  MY_AFFILIATES = 91,
  WEBHOOK = 96,
  CHECKOUT_SUN = 98,
  REPORT_CENTER = 105,
  ANALYTICS = 107,
  BLINKET = 110,
  INSIDE_SALES = 111,
}
